
import Vue from 'vue'
import UiSkeleton from '@/components/UiSkeleton.vue'
import UiIcon from '@/components/UiIcon.vue'
import { Tweet } from 'vue-tweet-embed'

export default Vue.extend({
  name: "PostTweets",
  props: {
    tweets: Array,
    onDelete: Function,
    isEditable: Boolean
  },
  data(){
    return {
      tweet: null,
    }
  },
  computed: {},
  methods: {},
  components: {
    UiSkeleton,
    UiIcon,
    Tweet,
  }
})
